export enum Permissions {
  ROLE_SUPPER_ADMIN = "ROLE_SUPPER_ADMIN",
  ADMIN = "ADMIN",
  CLIENT = "CLIENT",
}
